module.exports = __webpack_public_path__ + "menu_0.e0b6db3a.png";